/** @jsx jsx */
import { jsx, ThemeProvider } from '@emotion/react'
import { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import mq from '../styles/mediaQueries'
import animationData from '../assets/lotties/white-outline-thumb.json'
import { Player } from '@lottiefiles/react-lottie-player'
import ContactSVG from '../assets/icons/contactcircle.svg'
import { Link } from 'gatsby'

const whiteTheme = {
  fillColor: 'var(--terminal-0)',
  strokeColor: 'var(--screen-500)',
  hoverFillColor: 'var(--screen-500)',
  hoverStrokeColor: 'var(--terminal-0)',
}

const greyTheme = {
  fillColor: 'var(--terminal-50)',
  strokeColor: 'var(--screen-500)',
  hoverFillColor: 'var(--screen-500)',
  hoverStrokeColor: 'var(--terminal-0)',
}

const transparentTheme = {
  fillColor: 'transparent',
  strokeColor: 'var(--terminal-0)',
  hoverFillColor: 'var(--terminal-0)',
  hoverStrokeColor: 'var(--screen-500)',
}

const darkTheme = {
  fillColor: 'var(--terminal-500)',
  strokeColor: 'var(--terminal-0)',
  hoverFillColor: 'var(--terminal-0)',
  hoverStrokeColor: 'var(--firewall-500)',
}

const ContactWrapper = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto;
  cursor: pointer;
  ${mq({
    height: ['120px', '200px', '200px', '200px', '200px'],
    width: ['120px', '200px', '200px', '200px', '200px'],
  })};
`

const spin = keyframes`
  100% {
    transform: rotate(360deg);
  }
`

const OverlayContact = styled(ContactSVG)`
  position: absolute;
  animation: ${spin} 3.5s linear infinite;
  z-index: 2;

  path {
    stroke: ${props =>
      props.hovered ? props.theme.hoverStrokeColor : props.theme.strokeColor};
    fill: ${props =>
      props.hovered ? props.theme.hoverStrokeColor : props.theme.strokeColor};
  }

  circle:not(:first-of-type) {
    stroke: ${props =>
      props.hovered
        ? props.theme.hoverStrokeColor
        : props.theme.hoverFillColor};
  }

  circle {
    fill: ${props =>
      props.hovered ? props.theme.hoverFillColor : props.theme.fillColor};
  }

  ${mq({
    height: ['120px', '200px', '200px', '200px', '200px'],
    width: ['120px', '200px', '200px', '200px', '200px'],
  })};
`

const LottieWrapper = styled.div`
  z-index: 3;
  ${mq({
    height: ['120px', '200px', '200px', '200px', '200px'],
    width: ['120px', '200px', '200px', '200px', '200px'],
  })};

  path {
    stroke: ${props =>
      props.hovered ? props.theme.hoverStrokeColor : props.theme.strokeColor};
    fill: ${props =>
      props.hovered ? props.theme.hoverFillColor : props.theme.fillColor};
  }
`

function Contact({ colorTheme }) {
  const [theme, setTheme] = useState(whiteTheme)
  const [hovered, setHovered] = useState(false)

  useEffect(() => {
    if (colorTheme === 'white') {
      setTheme(whiteTheme)
    }
    if (colorTheme === 'grey') {
      setTheme(greyTheme)
    }
    if (colorTheme === 'transparent') {
      setTheme(transparentTheme)
    }
    if (colorTheme === 'dark') {
      setTheme(darkTheme)
    }
  }, [colorTheme])

  return (
    <ContactWrapper
      to="/contact"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <ThemeProvider theme={theme}>
        <OverlayContact hovered={hovered ? 1 : undefined} />
        <LottieWrapper hovered={hovered ? 1 : undefined}>
          <Player
            autoplay={false}
            hover={true}
            loop={true}
            src={animationData}
          />
        </LottieWrapper>
      </ThemeProvider>
    </ContactWrapper>
  )
}

export default Contact
